import React from 'react';
import * as errorStyle1 from './errorStyle1.json';
import Lottie from 'react-lottie';
import FadeIn from 'react-fade-in';
import { Box, Typography } from '@material-ui/core';

const Error = ({ errorStatus, errorMessage }) => {
   const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: errorStyle1.default,
      rendererSettings: {
         preserveAspectRatio: 'xMidYMid slice',
      },
   };
   return (
      <React.Fragment>
         <Box
            display={'flex'}
            alignContent={'center'}
            alignItems={'center'}
            justifyContent={'center'}
         >
            <FadeIn>
               <Lottie options={defaultOptions} height={180} width={180} />
               <Typography
                  variant={'h6'}
               >{`Oops!! ${errorStatus}: ${errorMessage}`}</Typography>
            </FadeIn>
         </Box>
      </React.Fragment>
   );
};
export default Error;
